import { CellProps, getCellClasses } from 'components/TableV2/Cell/Cell';
import React from 'react';
import styles from './SpecialCells.module.scss';
import PaymentTypeIcon from 'pages/Transactions/components/PaymentTypeIcon';

export const CardBrandCell = ({ rowData, columnName, classes }: CellProps) => {
  return (
    <div className={getCellClasses(classes, styles.cardBrandCell)}>
      <PaymentTypeIcon code={rowData[columnName]} />
    </div>
  );
};
